var $ = jQuery.noConflict();

$(window).on('load', function () {
    let method = 'front';
    if ($('body').hasClass('wp-admin'))
        method = 'wp-admin';

        var initializeBlock = function ($block) {

        // Place for your code

    };

    window.onload = function () {
        initializeBlock($(this));
    }();

    if (window.acf) {
        window.acf.addAction('render_block_preview/type=tiles', initializeBlock);
    }
});
